import {CompanyService} from "./company/CompanyService";
import {CurrentUserService} from "./user/CurrentUserService";
import {SystemEventService} from "./system-state/SystemEventService";
import {UserService} from "./user/UserService";
import {BreakpointObserver} from "./breakpoints/BreakpointObserver";
import {HistoricalOptionService} from "./option/HistoricalOptionService";
import {ExpiryService} from "./expiry/ExpiryService";
import {HolidayService} from "./holiday/HolidayService";
import {CookbookService} from "./cookbook/CookbookService";
import {ServiceWorkerService} from "./service-worker/ServiceWorkerService";
import {MilestoneService} from "./milestone/MilestoneService";
import {MilestoneStore} from "./milestone/MilestoneStore";
import {StrategiesService} from "./cookbook/StrategiesService";
import {RecentPortfolioService} from "./favourite-portfolios/RecentPortfolioService";
import {BrowserThemeStore} from "./browser-theme/BrowserThemeStore";
import {CrispService} from "./crisp/CrispService";
import {ClientEventService} from "./client-events/ClientEventService";

import Dialogs from "./dialogs";
import IV from "./iv";
import Price from "./price";
import OptionChain from "./option-chain";
import {CourseOfSalesService} from "./course-of-sales/CourseOfSalesService";
import {DepthService} from "./depth/DepthService";
import {UserInterfaceConfigurationService} from "./configuration/UserInterfaceConfigurationService";
import {ZenDeskService} from "./zendesk/ZenDeskService";
import {OpenTraderConversionEventService} from "./open-trader/google/OpenTraderConversionEventService";
import {GameConversionEventService} from "./game/google/GameConversionEventService";

export default angular.module("tfApp.services", [Dialogs(), IV, OptionChain, Price])
                      .service(CompanyService.id, CompanyService)
                      .service(CurrentUserService.id, CurrentUserService)
                      .service(SystemEventService.id, SystemEventService)
                      .service(UserService.id, UserService)
                      .service(BreakpointObserver.id, BreakpointObserver)
                      .service(HistoricalOptionService.id, HistoricalOptionService)
                      .service(ExpiryService.id, ExpiryService)
                      .service(HolidayService.id, HolidayService)
                      .service(CookbookService.id, CookbookService)
                      .service(ServiceWorkerService.id, ServiceWorkerService)
                      .service(MilestoneService.id, MilestoneService)
                      .service(MilestoneStore.id, MilestoneStore)
                      .service(StrategiesService.id, StrategiesService)
                      .service(CrispService.id, CrispService)
                      .service(ZenDeskService.id, ZenDeskService)
                      .service(RecentPortfolioService.id, RecentPortfolioService)
                      .service(BrowserThemeStore.id, BrowserThemeStore)
                      .service(ClientEventService.id, ClientEventService)
                      .service(CourseOfSalesService.id, CourseOfSalesService)
                      .service(DepthService.id, DepthService)
                      .service(UserInterfaceConfigurationService.id, UserInterfaceConfigurationService)
                      .service(OpenTraderConversionEventService.id, OpenTraderConversionEventService)
                      .service(GameConversionEventService.id, GameConversionEventService)
                      .name;
